import api from './api';

const attritionOccupancyService = {
  getDashboard: (params = {}) =>
    api.get('/attrition-occupancy/dashboard', { params, timeout: 120000 }).then(r => r.data),

  getRecords: (params = {}) =>
    api.get('/attrition-occupancy/records', { params, timeout: 60000 }).then(r => r.data),

  getFilterOptions: () =>
    api.get('/attrition-occupancy/filter-options', { timeout: 60000 }).then(r => r.data),

  getOccupancyStats: () =>
    api.get('/attrition-occupancy/occupancy-stats', { timeout: 60000 }).then(r => r.data),

  getOccupancyBreakdown: () =>
    api.get('/attrition-occupancy/occupancy-breakdown').then(r => r.data),

  getDivisionDesignationMatrix: () =>
    api.get('/attrition-occupancy/division-designation-matrix', { timeout: 60000 }).then(r => r.data),

  getVacantAging: () =>
    api.get('/attrition-occupancy/vacant-aging', { timeout: 60000 }).then(r => r.data),

  // ── TA Tracker ──────────────────────────────────────────────────
  getTaStats: () =>
    api.get('/attrition-occupancy/ta-stats', { timeout: 30000 }).then(r => r.data),

  getTaRecords: (params = {}) =>
    api.get('/attrition-occupancy/ta-records', { params, timeout: 60000 }).then(r => r.data),

  uploadTaExcel: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/attrition-occupancy/ta-upload', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 120000,
    }).then(r => r.data);
  },

  downloadTaSampleFormat: () =>
    api.get('/attrition-occupancy/ta-sample-format', { responseType: 'blob', timeout: 30000 }).then(r => r.data),

  uploadExcel: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/attrition-occupancy/upload-excel', fd, {
      headers: { 'Content-Type': 'multipart/form-data' },
      timeout: 300000, // 5 min — 7000+ rows can take 60-90s to parse + insert
    }).then(r => r.data);
  },

  // Section Strength
  getAllStrengths: (includeInactive = false) =>
    api.get('/attrition-occupancy/strength', { params: { includeInactive } }).then(r => r.data),

  createStrength: (data) =>
    api.post('/attrition-occupancy/strength', data).then(r => r.data),

  updateStrength: (id, data) =>
    api.put(`/attrition-occupancy/strength/${id}`, data).then(r => r.data),

  deleteStrength: (id) =>
    api.delete(`/attrition-occupancy/strength/${id}`).then(r => r.data),
};

export default attritionOccupancyService;
